import { nanoid } from 'nanoid';
import { allIndexesInString } from './allIndexesInString';
import { simplifyPortableTextSpans } from './simplifyPortableTextSpans';
import type { TPortableText } from '@typings/TPortableText';

export const highlightWordsInPortableText = (pt: TPortableText, terms: string[]) => {
  return pt.map(v => {
    if (v._type === 'block') {
      const children = [...v.children ?? []];
      const fulltext = children.reduce((acc, v) => acc + v.text, '');
      const termIndexes = terms.map(t => allIndexesInString(fulltext.toLowerCase(), t.toLowerCase()));
      const characterChildren = children.reduce<typeof children>((acc, v) => {
        const chars = Array.from(v.text);
        return acc.concat(chars.map(c => ({ ...v, _key: nanoid(), text: c, marks: [...v.marks] })));
      }, []);

      termIndexes.forEach((indexes, index) => {
        const term = terms[index];
        indexes.forEach(idx => {
          for (let i = idx; i < idx + term.length; i++) {
            const isHighlighted = characterChildren[i].marks.includes('highlight');
            if (!isHighlighted) { characterChildren[i].marks.push('highlight'); }
          }
        });
      });
      return {
        ...v,
        children: simplifyPortableTextSpans(characterChildren),
      };
    }
    return v;
  });
}